import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAdsExpensesComponent } from '../../abstract-components/base-ads-expenses.component';

@Component({
  selector: 'ads-expenses-layout',
  standalone: false,
  templateUrl: './ads-expenses-layout.component.html',
  styleUrl: './ads-expenses-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdsExpensesLayoutComponent extends BaseAdsExpensesComponent {}
